export type GtmEventValue = boolean | number | string | null | undefined
export type GtmEventData = Record<string, GtmEventValue | GtmEventValue[] | Record<string, GtmEventValue>>

export function gtmEvent(event: string, data: GtmEventData = {}) {
  const dataLayer = getDataLayer()

  if (!dataLayer) {
    return
  }

  dataLayer.push({ event, ...data })
}

function getDataLayer() {
  if (typeof window === 'undefined') {
    return null
  }

  window.dataLayer = window.dataLayer || []

  return window.dataLayer
}
